export default __webpack_public_path__ + "static/media/DEGO-BNB.cbfe2276.svg";